function isWebmBlob(blob) {
  const mime = (blob?.type || "").split(";")[0].trim().toLowerCase();
  return !mime || mime === "video/webm" || mime === "video/x-matroska";
}

/** Corrige durée / index seek des WebM MediaRecorder (barre de navigation admin). */
export async function prepareRecordingBlob(blob) {
  if (!blob?.size || !isWebmBlob(blob)) return blob;
  try {
    const { default: fixWebmDuration } = await import("webm-duration-fix");
    return await fixWebmDuration(blob);
  } catch (err) {
    console.warn("[video] correction métadonnées WebM impossible", err);
    return blob;
  }
}

export function recordingFileExtension(blob) {
  const mime = (blob?.type || "").split(";")[0].trim().toLowerCase();
  if (mime === "video/mp4" || mime === "video/quicktime" || mime === "video/x-mp4") return "mp4";
  return "webm";
}
